import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { API } from "@/App";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    const processSession = async () => {
      try {
        const res = await fetch(`${API}/auth/session?session_id=${sessionId}`, {
          credentials: "include",
        });
        if (res.ok) {
          const data = await res.json();
          login(data);
          navigate("/dashboard", { replace: true, state: { user: data } });
        } else {
          navigate("/auth", { replace: true });
        }
      } catch {
        navigate("/auth", { replace: true });
      }
    };

    processSession();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-4 border-[#20D3C0] border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-[#193B6E] font-medium" style={{ fontFamily: 'DM Sans' }}>Iniciando sesion...</p>
      </div>
    </div>
  );
}
